import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.resetPassword.title',
        defaultMessage: 'Reset password'
    },
    success: {
        id: 'app.resetPassword.success',
        defaultMessage: 'Password saved! You\'ll be redirected'
    }
});
